export const translations = {
  en: {
    // Guest Page
    welcomeTo: "Welcome to",
    mainHeading: "How is your stay so far?",
    tapToRate: "Tap a star to rate",
    ratingWords: ["", "Poor", "Below expectations", "Okay", "Very good", "Excellent"],
    highRatingMessage: "We are thrilled to hear that! Would you share your experience on Google? It takes under a minute.",
    reviewOnGoogleMaps: "Review on Google",
    lowRatingMessage: "We are sorry your stay isn't perfect yet. Tell us what happened — the front desk will see it right away.",
    feedbackPlaceholder: "What can we fix for you?",
    roomNumberPlaceholder: "Room number (optional)",
    roomAutoDetected: "Room {room} · detected from your QR code",
    sendToFrontDesk: "Send to front desk",
    sending: "Sending…",
    alsoGoogle: "Prefer to leave a public review instead?",
    alsoGoogleLink: "Write a Google review",
    thankYou: "Thank you",
    confirmationMessage: "Our team has been notified and will assist you shortly.",
    confirmationHigh: "Thank you for staying with us. Your review helps other travellers.",
    poweredBy: "Powered by RateGuard",
    changeRating: "Change rating",

    // Admin Page
    dashboardTitle: "RateGuard Dashboard",
    feedbackManagement: "Guest feedback",
    refresh: "Refresh",
    totalFeedback: "Total feedback",
    averageRating: "Average rating",
    positive: "Positive (4–5)",
    negative: "Needs attention (1–3)",
    recentFeedback: "Recent feedback",
    noFeedback: "No feedback yet. Place your QR codes in rooms and it will appear here in real time.",
    rating: "Rating",
    message: "Message",
    room: "Room",
    date: "Date",
    status: "Status",
    actions: "Actions",
    noMessage: "No message",
    pending: "Open",
    resolved: "Resolved",
    markResolved: "Mark resolved",
    reopen: "Reopen",
    delete: "Delete",
    confirmDelete: "Delete?",
    settings: "Settings",
    googleMapsUrl: "Google review link",
    hotelName: "Hotel name",
    logoUrl: "Logo URL",
    notificationEmail: "Notification email",
    saveSettings: "Save settings",
    logout: "Log out",
    guestLink: "Guest link",
    copy: "Copy",
    copied: "Copied",
    lowAlert: "Low rating · Room {room} · {stars}★",
    liveAlerts: "Live alerts on",
    soundOn: "Sound alerts on",
    soundOff: "Turn on sound alerts",
    soundHint: "Click once so the browser can play the alert sound. Keep this tab open at reception.",
    alertTitle: "New complaint",
    alertsWaiting: "{n} waiting",
    seen: "Seen, handling it",
    seenAll: "Mark all seen",

    // Login
    adminLogin: "Hotel login",
    adminLoginSub: "Sign in to see your guests' feedback live.",
    hotelId: "Hotel ID",
    password: "Password",
    enterPassword: "Your password",
    login: "Sign in",
    invalidPassword: "Hotel ID or password is incorrect",

    // Toasts
    feedbackSubmitted: "Feedback sent",
    feedbackFailed: "Could not send. Please try again.",
    statusUpdated: "Status updated",
    feedbackDeleted: "Feedback deleted",
    settingsSaved: "Settings saved",
    saveFailed: "Could not save",
    sessionExpired: "Your session expired. Please sign in again.",
    thankYouForFeedback: "Thank you for your feedback!",
  },

  tr: {
    // Guest Page
    welcomeTo: "Hoş geldiniz",
    mainHeading: "Konaklamanız nasıl geçiyor?",
    tapToRate: "Puan vermek için bir yıldıza dokunun",
    ratingWords: ["", "Kötü", "Beklentinin altında", "İdare eder", "Çok iyi", "Mükemmel"],
    highRatingMessage: "Bunu duymak bizi çok mutlu etti! Deneyiminizi Google'da paylaşır mısınız? Bir dakikadan kısa sürer.",
    reviewOnGoogleMaps: "Google'da değerlendir",
    lowRatingMessage: "Konaklamanız henüz kusursuz değil, üzgünüz. Ne olduğunu yazın; resepsiyon hemen görsün.",
    feedbackPlaceholder: "Sizin için neyi düzeltebiliriz?",
    roomNumberPlaceholder: "Oda numarası (isteğe bağlı)",
    roomAutoDetected: "Oda {room} · QR koddan algılandı",
    sendToFrontDesk: "Resepsiyona gönder",
    sending: "Gönderiliyor…",
    alsoGoogle: "Herkese açık bir yorum mu bırakmak istersiniz?",
    alsoGoogleLink: "Google'da yorum yaz",
    thankYou: "Teşekkürler",
    confirmationMessage: "Ekibimiz bilgilendirildi, en kısa sürede sizinle ilgilenecek.",
    confirmationHigh: "Bizi tercih ettiğiniz için teşekkürler. Yorumunuz diğer misafirlere yol gösterir.",
    poweredBy: "RateGuard altyapısıyla",
    changeRating: "Puanı değiştir",

    // Admin Page
    dashboardTitle: "RateGuard Paneli",
    feedbackManagement: "Misafir geri bildirimleri",
    refresh: "Yenile",
    totalFeedback: "Toplam geri bildirim",
    averageRating: "Ortalama puan",
    positive: "Olumlu (4–5)",
    negative: "İlgi bekleyen (1–3)",
    recentFeedback: "Son geri bildirimler",
    noFeedback: "Henüz geri bildirim yok. QR kodları odalara yerleştirin; bildirimler burada anlık görünecek.",
    rating: "Puan",
    message: "Mesaj",
    room: "Oda",
    date: "Tarih",
    status: "Durum",
    actions: "İşlemler",
    noMessage: "Mesaj yok",
    pending: "Açık",
    resolved: "Çözüldü",
    markResolved: "Çözüldü olarak işaretle",
    reopen: "Yeniden aç",
    delete: "Sil",
    confirmDelete: "Silinsin mi?",
    settings: "Ayarlar",
    googleMapsUrl: "Google yorum bağlantısı",
    hotelName: "Otel adı",
    logoUrl: "Logo URL",
    notificationEmail: "Bildirim e-postası",
    saveSettings: "Ayarları kaydet",
    logout: "Çıkış",
    guestLink: "Misafir bağlantısı",
    copy: "Kopyala",
    copied: "Kopyalandı",
    lowAlert: "Düşük puan · Oda {room} · {stars}★",
    liveAlerts: "Canlı uyarılar açık",
    soundOn: "Sesli uyarı açık",
    soundOff: "Sesli uyarıyı aç",
    soundHint: "Tarayıcının uyarı sesini çalabilmesi için bir kez tıklayın. Bu sekmeyi resepsiyonda açık tutun.",
    alertTitle: "Yeni şikâyet",
    alertsWaiting: "{n} bekliyor",
    seen: "Gördüm, ilgileniyorum",
    seenAll: "Hepsini gördüm",

    // Login
    adminLogin: "Otel girişi",
    adminLoginSub: "Misafir geri bildirimlerini canlı görmek için giriş yapın.",
    hotelId: "Otel kimliği",
    password: "Şifre",
    enterPassword: "Şifreniz",
    login: "Giriş yap",
    invalidPassword: "Otel kimliği veya şifre hatalı",

    // Toasts
    feedbackSubmitted: "Geri bildirim gönderildi",
    feedbackFailed: "Gönderilemedi. Lütfen tekrar deneyin.",
    statusUpdated: "Durum güncellendi",
    feedbackDeleted: "Geri bildirim silindi",
    settingsSaved: "Ayarlar kaydedildi",
    saveFailed: "Kaydedilemedi",
    sessionExpired: "Oturum süresi doldu. Lütfen tekrar giriş yapın.",
    thankYouForFeedback: "Geri bildiriminiz için teşekkürler!",
  },
  sr: {
    // Guest Page
    welcomeTo: "Dobro došli",
    mainHeading: "Kako vam protiče boravak?",
    tapToRate: "Dodirnite zvezdicu da ocenite",
    ratingWords: ["", "Loše", "Ispod očekivanja", "Solidno", "Veoma dobro", "Odlično"],
    highRatingMessage: "Drago nam je što to čujemo! Da li biste podelili svoje iskustvo na Google-u? Traje manje od minut.",
    reviewOnGoogleMaps: "Ocenite nas na Google-u",
    lowRatingMessage: "Žao nam je što vaš boravak još nije savršen. Napišite nam šta se desilo — recepcija će to odmah videti.",
    feedbackPlaceholder: "Šta možemo da popravimo za vas?",
    roomNumberPlaceholder: "Broj sobe (opciono)",
    roomAutoDetected: "Soba {room} · prepoznato iz QR koda",
    sendToFrontDesk: "Pošalji recepciji",
    sending: "Šalje se…",
    alsoGoogle: "Želite li radije da ostavite javnu recenziju?",
    alsoGoogleLink: "Napišite recenziju na Google-u",
    thankYou: "Hvala vam",
    confirmationMessage: "Naš tim je obavešten i uskoro će vam pomoći.",
    confirmationHigh: "Hvala što ste odseli kod nas. Vaša recenzija pomaže drugim putnicima.",
    poweredBy: "Pokreće RateGuard",
    changeRating: "Promeni ocenu",

    // Admin Page
    dashboardTitle: "RateGuard kontrolna tabla",
    feedbackManagement: "Utisci gostiju",
    refresh: "Osveži",
    totalFeedback: "Ukupno utisaka",
    averageRating: "Prosečna ocena",
    positive: "Pozitivni (4–5)",
    negative: "Zahteva pažnju (1–3)",
    recentFeedback: "Najnoviji utisci",
    noFeedback: "Još nema utisaka. Postavite QR kodove u sobe i utisci će se ovde pojavljivati uživo.",
    rating: "Ocena",
    message: "Poruka",
    room: "Soba",
    date: "Datum",
    status: "Status",
    actions: "Akcije",
    noMessage: "Bez poruke",
    pending: "Otvoreno",
    resolved: "Rešeno",
    markResolved: "Označi kao rešeno",
    reopen: "Ponovo otvori",
    delete: "Obriši",
    confirmDelete: "Obrisati?",
    settings: "Podešavanja",
    googleMapsUrl: "Google link za recenzije",
    hotelName: "Naziv hotela",
    logoUrl: "URL logotipa",
    notificationEmail: "E-pošta za obaveštenja",
    saveSettings: "Sačuvaj podešavanja",
    logout: "Odjava",
    guestLink: "Link za goste",
    copy: "Kopiraj",
    copied: "Kopirano",
    lowAlert: "Niska ocena · Soba {room} · {stars}★",
    liveAlerts: "Obaveštenja uživo uključena",
    soundOn: "Zvučna upozorenja uključena",
    soundOff: "Uključi zvučna upozorenja",
    soundHint: "Kliknite jednom kako bi pregledač mogao da pusti zvuk upozorenja. Držite ovu karticu otvorenu na recepciji.",
    alertTitle: "Nova žalba",
    alertsWaiting: "{n} čeka",
    seen: "Videli smo, rešavamo",
    seenAll: "Označi sve kao viđeno",

    // Login
    adminLogin: "Prijava hotela",
    adminLoginSub: "Prijavite se da biste uživo videli utiske gostiju.",
    hotelId: "ID hotela",
    password: "Lozinka",
    enterPassword: "Vaša lozinka",
    login: "Prijava",
    invalidPassword: "ID hotela ili lozinka nisu tačni",

    // Toasts
    feedbackSubmitted: "Utisak je poslat",
    feedbackFailed: "Slanje nije uspelo. Pokušajte ponovo.",
    statusUpdated: "Status ažuriran",
    feedbackDeleted: "Utisak obrisan",
    settingsSaved: "Podešavanja sačuvana",
    saveFailed: "Čuvanje nije uspelo",
    sessionExpired: "Sesija je istekla. Prijavite se ponovo.",
    thankYouForFeedback: "Hvala na utisku!",
  },
};

export const fmt = (str, vars = {}) =>
  Object.entries(vars).reduce((s, [k, v]) => s.replaceAll(`{${k}}`, v ?? "—"), str);

export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations.en[key] || key;
};
